var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 56,
    height: 56
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_1223_1311_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0525 21.8964L21.4075 15.3265C21.0272 15.1092 20.5961 14.9965 20.1581 14.9998C19.7201 15.0032 19.2908 15.1225 18.9139 15.3456C18.5467 15.5556 18.2416 15.8591 18.0296 16.2252C17.8176 16.5913 17.7063 17.007 17.707 17.43V30.5698C17.7063 30.9929 17.8176 31.4086 18.0296 31.7747C18.2416 32.1408 18.5467 32.4443 18.9139 32.6543C19.2908 32.8773 19.7201 32.9965 20.1581 32.9999C20.5961 33.0032 21.0272 32.8906 21.4075 32.6733L33.0525 26.1034C33.4281 25.8954 33.7411 25.5906 33.959 25.2207C34.177 24.8508 34.2919 24.4293 34.2919 23.9999C34.2919 23.5706 34.177 23.1491 33.959 22.7792C33.7411 22.4093 33.4281 22.1045 33.0525 21.8964Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1223_1311_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBtn);
export default __webpack_public_path__ + "static/media/video-btn.68c15be74af1a984baabe4b00da3260c.svg";
export { ForwardRef as ReactComponent };